<template>
  <div class="feed">
    <image-feed></image-feed>
  </div>
</template>

<script>
import ImageFeed from "@/components/ImageFeed.vue";
export default {
  name: "Feed",
  components: {
    ImageFeed
  }
};
</script>
